import { Link } from "react-router-dom";
import Logo from "@/components/Logo";

export default function PublicFooter({ keywords = [] }) {
  return (
    <footer className="border-t border-panel-border bg-panel-header mt-20">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 py-12 grid gap-10 md:grid-cols-4">
        <div className="md:col-span-2">
          <Logo size="md" />
          <p className="mt-4 text-sm text-panel-secondary max-w-sm leading-relaxed">
            smsonay.site — WhatsApp, Telegram, Instagram ve 700+ servis için anında ve güvenilir
            <strong className="text-panel-text"> sms onay</strong> ve
            <strong className="text-panel-text"> sanal numara alma</strong> hizmeti. 180+ ülke, iade garantisi.
          </p>
        </div>
        <div>
          <h4 className="font-head font-semibold mb-3">Hızlı Bağlantılar</h4>
          <ul className="space-y-2 text-sm text-panel-secondary">
            <li><Link to="/" className="hover:text-brand-500">Ana Sayfa</Link></li>
            <li><Link to="/blog" className="hover:text-brand-500">Blog</Link></li>
            <li><Link to="/giris" className="hover:text-brand-500">Giriş Yap</Link></li>
            <li><Link to="/kayit" className="hover:text-brand-500">Üye Ol</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-head font-semibold mb-3">Popüler Servisler</h4>
          <ul className="space-y-2 text-sm text-panel-secondary">
            <li><Link to="/sms-onay/wa" className="hover:text-brand-500">WhatsApp SMS Onay</Link></li>
            <li><Link to="/sms-onay/tg" className="hover:text-brand-500">Telegram Sanal Numara</Link></li>
            <li><Link to="/sms-onay/ig" className="hover:text-brand-500">Instagram SMS Onay</Link></li>
            <li><Link to="/sms-onay/go" className="hover:text-brand-500">Google SMS Onay</Link></li>
          </ul>
        </div>
      </div>
      {keywords.length > 0 && (
        <div className="border-t border-panel-border">
          <div className="mx-auto max-w-7xl px-4 sm:px-6 py-5 flex flex-wrap gap-2">
            {keywords.map((k) => (
              <span key={k} className="text-[11px] text-panel-muted bg-panel-input rounded-full px-2.5 py-1 border border-panel-border">{k}</span>
            ))}
          </div>
        </div>
      )}
      <div className="border-t border-panel-border">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 py-5 text-xs text-panel-muted flex flex-col sm:flex-row justify-between gap-2">
          <span>© {new Date().getFullYear()} smsonay.site — Tüm hakları saklıdır.</span>
          <span>Güvenilir SMS Onay & Sanal Numara Paneli</span>
        </div>
      </div>
    </footer>
  );
}
